var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"to":_vm.to,"link":"","exact":"","active-class":_vm.color}},[_c('v-list-item-action',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_c('v-list-item-title',{domProps:{"textContent":_vm._s(_vm.text)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }